import { useEffect, useState } from "react";

const VideoComponent = ({
  videoData,
  selectedVideos,
  setSelectedVideos,
  totalVideos,
}: any) => {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    match();
  }, []);

  const match = () => {
    selectedVideos.forEach((videos_id: any) => {
      if (videos_id === videoData.id) {
        setIsChecked(true);
      }
    });
  };

  const handleCheckboxChange = () => {
    if (!isChecked && selectedVideos.length < totalVideos) {
      setSelectedVideos([...selectedVideos, videoData.id]);
      setIsChecked(!isChecked);
    } else if (isChecked) {
      setSelectedVideos(
        selectedVideos.filter((id: any) => id !== videoData.id)
      );
      setIsChecked(!isChecked);
    } else {
      return;
    }
  };
  return (
    <>
      <div
        className="relative flex h-[15rem] w-full flex-col items-center justify-start overflow-hidden rounded p-2"
        onClick={handleCheckboxChange}
      >
        <input
          type="checkbox"
          className="absolute right-2 top-2 z-10 h-4 w-4 accent-[#0098DA]"
          checked={isChecked}
          onChange={handleCheckboxChange}
        />
        {!isChecked && (
          <div className="absolute	top-0 min-h-full min-w-full bg-[#BDBDBD] bg-opacity-50"></div>
        )}

        <div>
          <img
            src={videoData?.thumbnail_url}
            alt="thumbnail"
            className="w-full"
          />
        </div>
        <div>{videoData?.title.slice(0, 30)}</div>

        <div>{videoData?.description.slice(0, 50)}</div>
      </div>
    </>
  );
};

export default VideoComponent;
